/**
 * Aviation acronyms that must stay uppercase when an all-caps note is re-cased
 * to sentence form (see utils/normalizeNoteCasing).
 *
 * These are acronyms that are NOT part of the ADS abbreviation-expansion set
 * (those are preserved separately so they survive re-casing and are then
 * expanded). Station and carrier codes are preserved via the shared STATIONS /
 * CARRIERS constants, so they are not repeated here.
 */
export const KNOWN_ACRONYMS: readonly string[] = [
  'AOG',
  'MEL',
  'MMEL',
  'CDL',
  'NEF',
  'IAW',
  'AMM',
  'CMM',
  'SRM',
  'WDM',
  'FIM',
  'TSM',
  'RII',
  'ETOPS',
  'CAT',
  'ATA',
  'QRH',
  'PIREP',
  'AD',
  'SB',
  'EO',
  'BER',
  'NDT',
  'GSE',
  'VOR',
  'DME',
  'ADF',
  'VHF',
  'HF',
  'UHF',
  'TAT',
  'OAT',
  'MOC',
  'MCC',
];
